import * as React from "react";
import { Box, Container } from "@mui/material";
import { platformPageSx } from "../tickitPlatformTheme";

export default function PlatformPage({ children, maxWidth = "xl" }) {
  return (
    <Box sx={platformPageSx}>
      <Container maxWidth={maxWidth} disableGutters sx={{ maxWidth: "100% !important" }}>
        {children}
      </Container>
    </Box>
  );
}
